import { frontendURL } from 'dashboard/helper/URLHelper';
const InboxListView = () => import('./InboxList.vue');
const InboxDetailView = () => import('./InboxView.vue');
const InboxEmptyStateView = () => import('./InboxEmptyState.vue');
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    name: 'inbox_view',
    redirect: { name: 'home' },
  },
  {
    path: frontendURL('accounts/:accountId/inbox-view/:type/:id'),
    name: 'inbox_view_conversation',
    redirect: to => {
      return {
        name: 'inbox_conversation',
        params: { conversation_id: to.params.id },
      };
    },
  },
];
